import React, {useCallback, useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
//MUI
import {
    Box,
    Button,
    Grid,
    Stack,
    Checkbox,
    Backdrop,
    Chip,
    CircularProgress,
    Typography
} from "@mui/material";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import UButton from "../../components/mui/UButton";
import UAuthButton from "../../components/mui/UAuthButton";
import UserModify from "./UserModify";
import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import UConfirmDialog from "../../components/mui/UConfirmDialog";
import UAlertDialog from "../../components/mui/UAlertDialog";
import UTable from "../../components/mui/UTable";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {theme} from "../../assets/themes";
import {API, PAGE} from "../../config";
import {fni18n, bytesToSize} from "../../services/commonService";
import {
    getAPI,
    postAPI,
    putAPI,
    deleteAPI,
} from "../../services/commonService";
import {FileService} from "../../services/FileService";
import AuthenticationService from "../../pages/auth/AuthenticationService";

import UTextField from "../../components/mui/UTextField";
import USelectBox from "../../components/mui/USelectBox";
import UPopupForm from "../../components/mui/UPopupForm";
import {makeStyles} from "@material-ui/core/styles";

const useYn = [
    {cd: "Y", name: "Y"},
    {cd: "N", name: "N"},
];

export default function UserPage() {
    const {t} = useTranslation();
    const userLoginId = AuthenticationService.getLoggedInUserID();
    const columns = [
        {
            field: "id",
            headerName: "번호",
            width: 90,
            headerAlign: "center",
            align: "center",

            hide: true,
        },
        {
            field: "userId",
            headerName: "사원번호",
            width: 150,
            editable: true,
            headerAlign: "center",
            align: "center",
            id: "1",
        },
        {
            field: "userNm",
            headerName: "사원명",
            width: 150,
            editable: true,
            headerAlign: "center",
            align: "center",
            id: "2",
        },
        {
            field: "grpNm",
            headerName: "그룹명",
            width: 130,
            editable: true,
            headerAlign: "center",
            align: "center",
            id: "3",
        },
        {
            field: "storeCd",
            headerName: "지점",
            width: 160,
            editable: true,
            headerAlign: "center",
            align: "center",
            id: "4",
            hide: true,
        },
        {
            field: "storeNm",
            headerName: "지점명",
            width: 160,
            editable: true,
            headerAlign: "center",
            align: "center",
            id: "4",
        },
        {
            field: "brandNm",
            headerName: "브랜드명",
            width: 160,
            editable: true,
            headerAlign: "center",
            align: "center",
            id: "4",
        },
        {
            field: "brandCd",
            headerName: "브랜드",
            width: 160,
            editable: true,
            headerAlign: "center",
            align: "center",
            id: "4",
            hide: true,
        },
        {
            field: "transLimtAmt",
            headerName: "1일출금한도",
            width: 100,
            editable: true,
            headerAlign: "center",
            align: "right",
            id: "5",
        },
        {
            field: "tillTotalAmt",
            headerName: "1회출금한도",
            width: 100,
            editable: true,
            headerAlign: "center",
            align: "right",
            id: "6",
        },
        {
            field: "useSetupDt",
            headerName: "유효기간",
            width: 110,
            editable: true,
            headerAlign: "center",
            align: "center",
            id: "7",
            hide: true,
        },
        {
            field: "regDt",
            headerName: "등록일",
            width: 150,
            editable: true,
            headerAlign: "center",
            align: "center",
            id: "8",
            hide: true,
        },
        {
            field: "useYn",
            headerName: "사용여부",
            width: 110,
            editable: true,
            headerAlign: "center",
            align: "center",
            valueFormatter: (params) => {
                if (params.value == "Y") {
                    return (
                        <Checkbox
                            checked={true}
                            disabled
                            style={{color: theme.palette.primary.main}}
                        />
                    );
                } else {
                    return <Checkbox checked={false} disabled/>;
                }
            },
            id: "9",
        },

        {
            field: "button",
            headerName: "설정",
            sortable: false,
            width: 100,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (
                <UButton
                    variant="outlined"
                    onButtonClick={() => handleRowSelect(params.rows)}
                    menuFrom={location.pathname}
                >
                    보기
                </UButton>
            ),
            id: "10",
        },
        {
            field: "delete",
            headerName: "삭제",
            sortable: false,
            width: 100,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (
                <UButton
                    variant="outlined"
                    onButtonClick={() => handleDelete(params.rows)}
                    menuFrom={location.pathname}
                >
                    삭제
                </UButton>
            ),
        },
    ];

    const location = useLocation();

    const [branchs, setBranch] = useState([]);
    const [groups, setGroups] = useState([]);
    const [brands, setBrands] = useState([]);
    const [retailers, setRetailers] = useState([]);

    const [search, setSearch] = useState({
        // branch: "N/A",
        // brandCd: "N/A",
        // useYn: "Y",
    });
    const [list, setList] = useState([]);

    const [confirmPopupOpen, setConfirmPopupOpen] = useState(false); // confirm dialog
    const [errorPopupOpen, setErrorPopupOpen] = useState(false); // error dialog
    const [errorMsg, setErrorMsg] = useState(""); // api error message
    const [confirmMsg, setConfirmMsg] = useState(""); // api error message
    const [confirmEvent, setConfirmEvent] = useState("");
    const [formOpen, setFormOpen] = useState(false);
    const [modify, setModify] = useState({});
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [excelFormOpen, setexcelFormOpen] = useState(false); //엑셀업로드 팝업
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [backdropOpen, setBackdropOpen] = useState(false);

    //화면 로드 시
    useEffect(() => {
        window.scrollTo(0, 0);
        const getLoadData = async () => {
            try {
                await Promise.all([
                    loadComboBoxBranchGroup(),
                    loadComboBoxBranch(),
                    loadComboBoxGroup()
                ]);
            } catch (e) {
                console.error('초기 로딩 실패:', e.message);
            }
        };
        getLoadData();
    }, []);

    useEffect(() => {
        if (!isFirstLoad) return;
        if (search.branch) {
            onButtonClick("조회");
            setIsFirstLoad(false);
        }
    }, [search]);

    const clearSearchVal = ()=>{
        setSearch({
            ...search,
            ['branch']: 'N/A',
        });
        setBrands([]);
    }

    // 콤보박스 데이터
    const loadComboBoxBranchGroup = async () => {
        try {
            const res = await getAPI(API.COMMON.BRANCH_GROUP, {userId: userLoginId,branchGroupTy: "BIZ_TY",useYn:"Y"});
            const _inputData = res.data.result.map((m) => ({
                cd: m.id,
                name: m.branchGroupNm,
            }));
            setRetailers(_inputData);
            // await loadComboBoxBranch(_inputData[0].cd);
        } catch (e) {
            console.error(e.message);
        }
    };
    const loadComboBoxBranch = async (param) => {
        try {
            const res = await getAPI(API.COMMON.BRANCH, { userId: userLoginId, bizTy:param, });
            const _inputData = res.data.result.map((m) => ({
                cd: m.storeCd,
                name: m.storeNm,
            }));
            setBranch(_inputData);
            if (_inputData.length > 0) {
                await loadComboBoxBrand(_inputData[0].cd);
            } else {
                clearSearchVal()
            }
        } catch (e) {
            console.error(e.message);
        }
    };
    const loadComboBoxGroup = async () => {
        try {
            const res = await getAPI(API.COMMON.USER_GROUP);
            const _inputData = res.data.result.map((m) => ({
                cd: m.grpCd,
                name: m.grpNm,
            }));
            setGroups(_inputData);
        } catch (e) {
            console.error(e.message);
        }
    };
    const loadComboBoxBrand = async (branch) => {
        try {
            const res = await getAPI(API.COMMON.BRAND, {
                userId: userLoginId,
                branch: branch,
            });
            const _inputData = res.data.result.map((m) => ({
                cd: m.brandCd,
                name: m.brandNm,
            }));
            if (_inputData.length > 0) {
                setSearch({
                    ...search,
                    ["brandCd"]: _inputData[0].cd,
                    ["branch"]: branch,
                });
            } else {
                setSearch({
                    ...search,
                    ["brandCd"]: "N/A",
                    ["branch"]: branch,
                });
            }
            setBrands(_inputData);
        } catch (e) {
            console.error(e.message);
        }
    };
    const handleConfirmOpen = (e) => {
        setConfirmPopupOpen(true);
        setConfirmEvent(e);
    };
    const handleConfirmClose = () => {
        setConfirmPopupOpen(false);
    };
    /**처리성공 시 팝업 띄우지 않는다. 실패 시에만 팝업 띄운다 */
    /**처리실패 시에는 창 닫지 않는다. 성공 시에만 자동 closed.*/
    const handelConfirmEvent = async () => {
        try {
            if (confirmEvent === "put") {
                await putAPI(API.OPER.USER, modify).then((res) => {
                    if (res.data.code === 200) {
                        handleFormClose();
                    } else {
                        setErrorMsg(t("처리가 실패하였습니다"));
                        handleErrorOpen();
                    }
                });
            } else if (confirmEvent === "post") {
                await postAPI(API.OPER.USER, modify).then((res) => {
                    if (res.data.code === 200) {
                        handleFormClose();
                    } else {
                        setErrorMsg(t("처리가 실패하였습니다"));
                        handleErrorOpen();
                    }
                });
            } else if (confirmEvent === "delete") {
                await deleteAPI(API.OPER.USER, modify).then((res) => {
                    if (res.data.code === 200) {
                        handleFormClose();
                    } else {
                        setErrorMsg(t("처리가 실패하였습니다"));
                        handleErrorOpen();
                    }
                });
            } else if (confirmEvent === "init") {
                await putAPI(API.OPER.PWD, modify).then((res) => {
                    if (res.data.code === 200) {
                        handleFormClose();
                    } else {
                        setErrorMsg(t("처리가 실패하였습니다"));
                        handleErrorOpen();
                    }
                });
            }
        } catch (error) {
            console.log(error);
        } finally {
            handleConfirmClose();
            await onButtonClick("조회");
        }
    };

    const handleErrorOpen = () => {
        setErrorPopupOpen(true);
    };
    const handleErrorClose = () => {
        setErrorPopupOpen(false);
    };

    const handleRowSelect = (row) => {
        setModify({
            storeCd: row.storeCd,
            storeNm: row.storeNm,
            brandCd: row.brandCd,
            brandNm: row.brandNm,
            userId: row.userId,
            userNm: row.userNm,
            grpNm: row.grpNm,
            useYn: row.useYn,
            tillTotal: row.tillTotal,
            useSetupDt: row.useSetupDt,
            outLimtCnt: row.outLimtCnt,
            create: row.create == true ? false : true,
        });
        handleFormOpen(); //상세팝업
    };

    const handleFormOpen = () => {
        setFormOpen(true);
    };
    const handleFormClose = () => {
        setFormOpen(false);
    };

    const handleExcelFormOpen = () => {
        setexcelFormOpen(true);
    };
    const handleExcelFormClose = () => {
        setexcelFormOpen(false);
    };

    const onModifyChange = (e) => {
        const {name, value} = e.target;
        setModify({
            ...modify,
            [name]: value,
        });
    };
    const onModifyStoreChage = (e) => {
        console.log(e);
        setModify({
            ...modify,
            brandCd: e.brandCd.value,
            storeCd: e.storeCd.value,
        });
    };

    //DataGrid에서 row 선택 시
    function onSelectedRow(row) {
    }

    const onSelectedRows = (e, row) => {
    };
    //value 속성으로만 값을 컨트롤 할 수 있어서
    //onChange를 써서 element를 수정할 수 있는 상태로 만듦

    //검색조건 값 변경되었을 때
    const onSearchChange = async (e) => {
        const {name, value} = e.target;
        setSearch({
            ...search,
            [name]: value,
        });
        if (name === "bizTy") {
            loadComboBoxBranch(value);
        }
        if (name == "branch") {
            await loadComboBoxBrand(value);
        }
    };

    const onCheckboxChange = (e) => {
        setModify({
            ...modify,
            [e.target.name]: e.target.checked === true ? "Y" : "N",
        });
    };

    async function onButtonClick(dvsn) {
        if (dvsn === "삭제") {
            let flag;
            await getAPI(API.OPER.USER + "/duplicateCheck", modify).then((res) => {
                flag = res.data;
            });
            if (flag == -1) {
                setErrorMsg(t("지점") + t("은(는) 필수 입력 항목입니다"));
                handleErrorOpen();
            } else if (flag == -2) {
                setErrorMsg(t("브랜드") + t("은(는) 필수 입력 항목입니다"));
                handleErrorOpen();
            } else if (flag == -3) {
                setErrorMsg(t("사용자ID") + t("은(는) 필수 입력 항목입니다"));
                handleErrorOpen();
            } else if (flag == -4) {
                setErrorMsg(t("사용자명") + t("은(는) 필수 입력 항목입니다"));
                handleErrorOpen();
            } else if (flag == -5) {
                setErrorMsg(t("사용자그룹") + t("은(는) 필수 입력 항목입니다"));
                handleErrorOpen();
            } else if (flag == 1) {
                setConfirmMsg(t("삭제하시겠습니까?") + modify.userId);
                handleConfirmOpen("delete");
            } else {
                setConfirmMsg(t("해당 정보가 존재하지 않습니다."));
                handleConfirmOpen("delete");
            }
        } else if (dvsn === "추가") {
            const today = new Date();
            today.setFullYear(today.getFullYear() + 3);
            // yyyy-mm-dd 형식으로 포맷팅
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            const row = {
                storeCd: "",
                brand: "",
                userId: "",
                userNm: "",
                grpNm: "",
                useYn: "Y",
                tillTotal: "",
                outLimtCnt: "",
                useSetupDt: formattedDate,
                create: true,
            };
            handleRowSelect(row);
        } else if (dvsn === "조회") {
            await getAPI(API.OPER.USER, search).then((res) => {
                if (res.data.code === 200) {
                    const _inputData = res.data.result.map((rowData) => ({
                        id: rowData.id,
                        userId: rowData.userId,
                        userNm: rowData.userNm,
                        storeCd: rowData.storeCd,
                        storeNm: rowData.storeNm,
                        brandNm: rowData.brandNm,
                        brandCd: rowData.brandCd,
                        grpNm: rowData.grpNm,
                        useSetupDt: rowData.useSetupDt,
                        regDt: rowData.regDt,
                        useYn: rowData.useYn,
                        tillTotal: rowData.tillTotal,
                        tillTotalAmt: isNaN(rowData.tillTotal)
                            ? "0"
                            : "$" + Number(rowData.tillTotal).toLocaleString("en-US"),
                        outLimtCnt: rowData.outLimtCnt,
                        transLimt: rowData.transLimt,
                        transLimtAmt: isNaN(rowData.transLimt)
                            ? "0"
                            : "$" + Number(rowData.transLimt).toLocaleString("en-US"),
                    }));
                    setList(_inputData);
                } else {
                    setErrorMsg(t("처리가 실패하였습니다"));
                    handleErrorOpen();
                }
            });
        } else if ("업로드") {
            var fileCnt = selectedFiles.length;
            if (fileCnt < 1) {
                setErrorMsg("선택된 파일이 없습니다. 파일을 선택해주세요."); //en,kr
                handleErrorOpen();
                return;
            }
            uploadExcelFile();
        } else {
            setErrorMsg(t("알 수 없는 오류가 발생하였습니다"));
            handleErrorOpen();
        }
    }

    const onSave = async (e) => {
        let flag;
        await getAPI(API.OPER.USER + "/duplicateCheck", modify).then((res) => {
            flag = res.data;
        });
        if (flag == -1) {
            setErrorMsg(t("지점") + t("은(는) 필수 입력 항목입니다"));
            handleErrorOpen();
        } else if (flag == -2) {
            setErrorMsg(t("브랜드") + t("은(는) 필수 입력 항목입니다"));
            handleErrorOpen();
        } else if (flag == -3) {
            setErrorMsg(t("사용자ID") + t("은(는) 필수 입력 항목입니다"));
            handleErrorOpen();
        } else if (flag == -4) {
            setErrorMsg(t("사용자명") + t("은(는) 필수 입력 항목입니다"));
            handleErrorOpen();
        } else if (flag == -5) {
            setErrorMsg(t("사용자그룹") + t("은(는) 필수 입력 항목입니다"));
            handleErrorOpen();
        } else if (flag == 0) {
            setConfirmMsg(t("등록하시겠습니까?"));
            handleConfirmOpen("post");
        } else if (flag > 0) {
            if (modify.create) {
                setConfirmMsg(t("정보를 수정하시겠습니까?") + " " + modify.userId);
                handleConfirmOpen("put");
            } else {
                setErrorMsg(t("동일한 사용자ID가 존재합니다"));
                handleErrorOpen();
            }
        }
    };
    const onPwdChange = () => {
        setConfirmMsg(t("비밀번호를 초기화하시겠습니까?") + " " + modify.userId);
        handleConfirmOpen("init");
    };

    // 엑셀 업로드
    const fnExcelBrowser = () => {
        const element = document.createElement("input");
        element.name = "file";
        element.type = "file";
        element.accept = ".xlsx, .xls, .csv";
        element.multiple = false;
        element.onchange = onSaveFile;
        element.click();
    };

    const onSaveFile = (e) => {
        const uploadFiles = Array.prototype.slice.call(e.target.files); // 파일선택창에서 선택한 파일들
        const _inputData = uploadFiles.map((m, i) => ({
            key: `file-+${i}`,
            label: `${m.name} (${bytesToSize(m.size)})`,
            file: m,
        }));
        setSelectedFiles(_inputData);
    };

    const uploadExcelFile = async () => {
        const fd = new FormData();

        Object.values(selectedFiles).forEach((f) => fd.append("file", f.file));
        fd.append("page", "user");

        try {
            await FileService.files(API.COMMON.UPLOAD_EXCEL, fd).then((res) => {
                console.log(res);
                if (res.status == '200' && res.data != "") {
                    let message = ""
                    if (res.data.errCode === -1) {
                        message = t(res.data.errMsg);
                    } else {
                        message = t("파일 업로드 데이터 저장") + "\n\n["
                            + t("저장 결과") + "]\n* "
                            + t("전체 개수") + " : " + res.data.total + "\n* "
                            + t("성공 개수") + " : " + res.data.success + "\n* "
                            + t("실패 개수") + " : " + res.data.fail;
                        if (res.data.fail !== 0)
                            message += " (" + res.data.failNoList.map(n => `No. ${n}`).join(', ') + ")";
                    }
                    setErrorMsg(message);
                    handleErrorOpen();
                    onButtonClick("조회");
                    handleExcelFormClose();
                } else {
                    setErrorMsg(t("실패"));
                    handleErrorOpen();
                    handleExcelFormClose();
                }
            });
        } catch (e) {
            console.log(e.message);
        }
    };

    const handleDelete = async(chipToDelete) => {

        await deleteAPI(API.OPER.USER, {userId:chipToDelete.userId,storeCd:chipToDelete.storeCd}).then((res) => {
            if (res.data.code === 200) {
                handleFormClose();
                onButtonClick("조회");
            } else {
                setErrorMsg(t("연결된 데이터가 존재하여 삭제되지 않았습니다."));
                handleErrorOpen();
            }
        });
    };

    return (
        <div className="main-container">
            <div className="header">
                <Grid container>
                    <Grid item xs={10}>
                        {/* 상단메뉴명 */}
                        <UBreadCrumbs title={"운영관리"} subtitle={"사용자관리"}/>
                    </Grid>
                    <Grid item xs={2}>
                        {/* 툴바 버튼 */}
                        <Stack
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="flex-start"
                            spacing={0.5}
                        >
                        </Stack>
                    </Grid>
                </Grid>
            </div>

            <div className="contents">
                <Box>
                    {/* 조회조건 */}
                    <TableContainer className="table-container">
                        <Table className="table" size="small">
                            <TableBody>
                                <TableRow className="table-row-header">
                                    <TableCell className="table-cell-title">{fni18n("고객사")}</TableCell>
                                    <TableCell className="table-cell">
                                        <USelectBox
                                            name="bizTy"
                                            items={retailers}
                                            onItemChange={onSearchChange}
                                        />
                                    </TableCell>
                                    <TableCell className="table-cell-title">{fni18n("지점")}</TableCell>
                                    <TableCell className="table-cell">
                                        {/* 점번선택 */}
                                        <USelectBox
                                            id="branch"
                                            name="branch"
                                            items={branchs}
                                            onItemChange={onSearchChange}
                                            defaultValue={search.branch}
                                        />
                                    </TableCell>
                                    <TableCell className="table-cell-title">{fni18n("브랜드")}</TableCell>
                                    <TableCell className="table-cell">
                                        {/* 기번선택 */}
                                        <USelectBox
                                            id="brandCd"
                                            name="brandCd"
                                            items={brands}
                                            onItemChange={onSearchChange}
                                            defaultValue={search.brandCd}
                                        />
                                    </TableCell>
                                    <TableCell className="table-cell-title">{fni18n("사용여부")}</TableCell>
                                    <TableCell className="table-cell">
                                        <USelectBox
                                            id="useYn"
                                            name="useYn"
                                            items={useYn}
                                            onItemChange={onSearchChange}
                                            defaultValue={search.useYn}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow className="table-row-header">
                                    <TableCell className="table-cell-title">{fni18n("사원번호")}</TableCell>
                                    <TableCell className="table-cell">
                                        {/* 사원번호 */}
                                        <UTextField name="userId" onChange={onSearchChange}/>
                                    </TableCell>
                                    <TableCell className="table-cell-title">{fni18n("사원명")}</TableCell>
                                    <TableCell className="table-cell">
                                        {/* 날짜선택 */}
                                        <UTextField name="userNm" onChange={onSearchChange}/>
                                    </TableCell>
                                    <TableCell className="table-cell"></TableCell>
                                    <TableCell className="table-cell"></TableCell>
                                    <TableCell className="table-cell"></TableCell>
                                    <TableCell className="table-cell"></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <div className="search">
                        <UButton icon="Search" onButtonClick={onButtonClick}>
                            조회
                        </UButton>
                    </div>
                </Box>
                {/* 조회 리스트 */}
                <UTable
                    columns={columns}
                    rows={list}
                    onSelectedRowChange={onSelectedRows}
                    rowPerPage={10}
                    toolbarAdd={
                        <>
                            <UAuthButton
                                icon="Add"
                                menuFrom={location.pathname}
                                onButtonClick={onButtonClick}
                            >
                                추가
                            </UAuthButton>
                            &nbsp;&nbsp;
                            <UAuthButton
                                icon="Upload"
                                onButtonClick={handleExcelFormOpen}
                            >
                                업로드
                            </UAuthButton>
                        </>
                    }
                />
            </div>
            <UConfirmDialog
                message={confirmMsg}
                open={confirmPopupOpen}
                onClose={handleConfirmClose}
                onClickOk={handelConfirmEvent}
            />
            <UAlertDialog
                message={errorMsg}
                open={errorPopupOpen}
                onClose={handleErrorClose}
            />
            {/* 팝업 */}
            <UPopupForm
                open={formOpen}
                onClose={handleFormClose}
                onSave={onSave}
                onSecondBt={onPwdChange}
                SecondBtName={"비밀번호초기화"}
                title="사용자 설정" //'사용자 생성 / 설정'
                type={modify.create ? "3" : "2"}
                content={
                    <UserModify
                        data={modify}
                        onParamsChange={onModifyChange}
                        onCheckboxChange={onCheckboxChange}
                        onPwdChange={onPwdChange}
                        setErrorMsg={setErrorMsg}
                        handleErrorOpen={handleErrorOpen}
                        onStoreChage={onModifyStoreChage}
                    />
                }
            />
            {/* EXCEL UPLOAD */}
            <div>
                <Dialog
                    open={excelFormOpen}
                    onClose={handleExcelFormClose}
                    aria-labelledby="draggable-dialog-title"
                    fullWidth={true}
                    maxWidth="md"
                >
                    <DialogTitle
                        style={{
                            backgroundColor: "#F6F6F6",
                            color: "#2F2F2F",
                            borderBottom: "1px solid #444444",
                            height: "50px",
                            fontSize: "20px",
                        }}
                        id="draggable-dialog-title"
                        onClose={handleExcelFormClose}
                    >
                        <Typography>{fni18n("업로드")}</Typography>
                        <IconButton
                            aria-label="close"
                            onClick={handleExcelFormClose}
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon/>
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {/* Excel 파일업로드  */}
                            <div className="pop-container">
                                <div className="contents">
                                    <TableContainer className="table-container">
                                        <Table className="table" size="small">
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell className="table-cell-title">
                                                        {fni18n("파일")}
                                                    </TableCell>
                                                    <TableCell className="table-cell" colspan={3}>
                                                        <Button
                                                            variant="text"
                                                            color="primary"
                                                            onClick={() => fnExcelBrowser()}
                                                        >
                                                            {fni18n("파일선택")}
                                                        </Button>
                                                        {selectedFiles &&
                                                            selectedFiles.map((data) => {
                                                                let icon;
                                                                return (
                                                                    <item key={data.key}>
                                                                        <Chip
                                                                            icon={icon}
                                                                            label={data.label}
                                                                            onDelete={handleDelete(data)}
                                                                        />
                                                                    </item>
                                                                );
                                                            })}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                            {/* END Excel 파일업로드 */}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{align: "center", backgroundColor: "#F6F6F6"}}>
                        <UAuthButton
                            variant="contained"
                            color="primary"
                            onButtonClick={onButtonClick}
                        >
                            업로드
                        </UAuthButton>
                        <UButton variant="outlined" onButtonClick={handleExcelFormClose}>
                            닫기
                        </UButton>
                    </DialogActions>
                    <Backdrop
                        sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
                        open={backdropOpen}
                    >
                        <CircularProgress color="inherit"/>
                    </Backdrop>
                </Dialog>
            </div>
        </div>
    );
}
